import { cssUtil } from "../../utils/cssUtil.js";
import { getBaseStyles, renderBackground } from "../commonStyles.js";

export async function renderContentCardWidget(
    context,
    widget,
    parent,
    override = null
) {

    const breakpoint = context.currentBreakpoint;

    let domainUrl = "";
    try {
        const domain = context.storyboard.domain;
        domainUrl = domain?.url ?? "";
    } catch (e) {
        console.warn("Domain not found");
    }

    const mapping = override?.content;
    const assetUrl = mapping?.url
        ? `${domainUrl}${mapping.url}`
        : "#";

    // Root card
    const cardEl = context.document.createElement("div");
    cardEl.classList.add("widget", "content_card_widget");

    const cardStyles = {
        ...getBaseStyles(widget, breakpoint),
        ...getCardStyles(context, widget, breakpoint)
    };

    cardEl.setAttribute("style", cssUtil.toStyleString(cardStyles));
    cardEl.setAttribute("data-widgetId", widget.uid);
    cardEl.setAttribute("data-widgetType", widget.type);
    cardEl.setAttribute("data-widgetParent", widget.parent);
    parent.appendChild(cardEl);

    // Anchor wrapper
    const anchor = context.document.createElement("a");
    anchor.classList.add("anchor", "anchor_style");
    anchor.href = assetUrl;

    const anchorStyles = {
        ...cardStyles,
        width: "100%"
    };
    delete anchorStyles.transform;

    anchor.setAttribute("style", cssUtil.toStyleString(anchorStyles));
    cardEl.appendChild(anchor);

    // Background
    renderBackground(context, widget, cardEl);

    // Render children
    const children = context.widgets.filter(
        w => w.parent === widget.uid
    );

    if (!children.length) return cardEl;
    
    for (const child of children) {
        const device = child?.properties?.[breakpoint];
        if (!device?.visible) continue;

        // Field-level visibility (mapping-driven)
        let visible = true;
        if (mapping?.fields?.length) {
            const field = mapping.fields.find(
                f => f.name === child.uid
            );
            if (field) visible = field.desktop;
        }

        if (!visible) continue;

        const renderer = context.renderers[child.type];
        if (!renderer) continue;
        const childOverride = { content: mapping };
        await renderer(context, child, cardEl, childOverride);
    }

    return cardEl;
}

function getCardStyles(context, widget, breakpoint) {
    const styles = {};

    const props = widget?.properties?.desktop;
    if (!props) return styles;

    // Border
    const border = props.border;
    if (border) {
        const radius = border.radius ?? {};

        if (radius.topLeft) styles["border-top-left-radius"] = `${radius.topLeft}px`;
        if (radius.topRight) styles["border-top-right-radius"] = `${radius.topRight}px`;
        if (radius.bottomRight) styles["border-bottom-right-radius"] = `${radius.bottomRight}px`;
        if (radius.bottomLeft) styles["border-bottom-left-radius"] = `${radius.bottomLeft}px`;

        if (border.color) {
            if (border.color.type === "gradient") {
                styles["border-color"] = cssUtil.getCssGradient(border.color);
            } else {
                styles["border-color"] = cssUtil.getCssColor(border.color);
            }
        }

        if (border.width) {
            styles["border-width"] = `${border.width}px`;
            styles["border-style"] = "solid";
        }
    }

    // Grid spacing (from parent Content widget)
    const parent = context.widgets.find(w => w.uid === widget.parent);
    if (parent?.type === "cleverstory.v2.widgets.content") {
        const parentProps = parent?.properties?.desktop;
        const layout = parentProps?.layoutStyle;

        if (layout?.type === "grid") {
            const columnSpacing = parseInt(layout.columnSpacing ?? 0);
            const rowSpacing = parseInt(layout.rowSpacing ?? 0);

            styles["margin-top"] = `${rowSpacing}px`;
            styles["margin-right"] = `${columnSpacing}px`;
        }
    }

    return styles;
}